module.exports = __webpack_public_path__ + "static/media/twitter.baef3767.svg";